/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import { computed, ComputedRef, watch } from '@vue/composition-api';
import { App } from '../../types';
import store from '../store';

const getPayVipAndUserInfo = async () => {
  try {
    if (store.state.isLogin) {
      await Promise.all([store.dispatch('getPayVip'), store.dispatch('getUserInfo')]);
    }
  } catch (err) {
    console.error('getPayVipAndUserInfo error: ', err);
  }
};

const useLoginReady = (app: ComputedRef<App>, vm: any) => {
  if (Vue.prototype.inPrerender) {
    return;
  }

  // eslint-disable-next-line
  const loginReady = new Promise(async (resolve) => {
    // 检查是否登录
    const isLogin = await store.dispatch('checkLogin');
    resolve(isLogin);
  });

  store.commit('saveLoginReady', loginReady);

  loginReady.then(async (isLogin) => {
    isLogin && (await getPayVipAndUserInfo());
  });

  const isLogin = computed(() => {
    if (!store) {
      return null;
    }
    return store.state.isLogin;
  });

  const isVip = computed(() => {
    if (!store) {
      return null;
    }
    return store.state.payVip?.vip;
  });

  watch(isLogin, (val) => {
    setTimeout(() => {
      if (val) {
        Vue.prototype.$bus.$emit('magic:common:events:logined', vm);
      } else {
        Vue.prototype.$bus.$emit('magic:common:events:logout', vm);
      }
    }, 10);
  }, {
    immediate: true,
  });

  watch(isVip, (val) => {
    if (!isLogin.value) return;
    setTimeout(() => {
      if (val === 1) {
        Vue.prototype.$bus.$emit('magic:common:events:isvip', vm);
      } else if (val === 0) {
        Vue.prototype.$bus.$emit('magic:common:events:notvip', vm);
      }
    }, 10);
  }, {
    immediate: true,
  });

  return {
    isLogin,
    isVip,
  };
};

export default useLoginReady;
